// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rounded-container {
    background: #ffffff;
    border-radius: 8px;
    margin: 8px;
}

.scanner-name {
    font-size: 40px;
    font-weight: 350;
    vertical-align: center;
    text-align: center;
}

.scanner-status {
    font-size:8px;
    vertical-align: middle;
}

.scanner-status-error {
    font-size:24px;
    text-align: center
}

.click-to-go-to-dash {
    width: 100% !important;
    text-align: center;
}


.scanner-main-control-buttons {
    font-size:18px;
    text-align: center;
    padding:1vw;
}

.scanner-start-button { 
    width: 50%;
    margin: 12px;
    font-size: 16px !important;
    font-weight: bold;
}

.scanner-start-button-div {
    text-align: center;
}

.scanner-start-button:hover{
    background-color: rgba(86, 46, 130, 0.06) !important;
    border: 1px solid #562e82;
}

.hardware-status-panel {
    border: 1px #d4d4d4 solid;
    border-radius: 8px;
    padding: 3px;
    margin-top: 32px;
    margin-bottom: 32px;
}

.hardware-status-row {
    border: 1px #c7bfbf solid;
    border-radius: 8px;
    padding: 8px !important;
    margin: 20px !important;
}

.hardware-section-header {
    text-align: center;
    font-size: 16px;
}

.hardware-section-retry {
    font-size: 13px;
}

.power-fail-message {
    text-align: center;
    font-weight: bold;
    font-size: 16px;
}

.troubleshoot-fail-message {
    text-align: center;
    font-weight: bold;
    font-size: 18px;
}

.troubleshoot-steps {
    margin: 32px;
}

.hardware-status-icon {
    text-align: center;
    font-size: 32px;
    line-height: 48px !important;
    vertical-align: middle;
}

.hardware-status-icon-div{
    text-align: center;
}

.scanner-main-control-icon {
    font-size:48px;
    padding: 1vw;
    padding-bottom: 0.5vw;
}

.scanner-main-control-icon-retake {
    font-size:16px;
    padding: 1vw;
    padding-bottom: 0.5vw;
}

.scanner-busy-card {
    vertical-align: middle;
    text-align: center;
    margin:10vw;
}

.scan-workflow-init {
    vertical-align: middle;
    text-align: center;
    font-size:1.32px;
}

a.scanner-user-controls{
    color:inherit;
}

.slot-header {
    font-size: 24px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif
}

.arial-font {
    font-family: Arial, Helvetica, sans-serif;
}

.region-selection-canvas {
    width:30vw;
    height:9vw;
    background-size: 100% 100%;
    cursor: crosshair;
    position:absolute;
    top:0;
    left:0;
    z-index: -1;
}

.region-selection-canvas-new {
    width:65vw;
    height:auto;
    background-size: 100% 100%;
    cursor: crosshair;
    position:absolute;
    top:0; 
    left:0;
    z-index: -1;
}


/* was 
width: 50vw;
height: 23.5vw;
*/
.c240-region-selection-canvas {
    width:60vw;
    height:26vw;
    background-size: 100% 100%;
    cursor: crosshair;
    position:absolute; top:0; left:0;
    z-index: -1;
}

.c240-region-selection-canvas-small {
    width: 60vw;
    height: 26vw;
    background-size: 100% 100%;
    cursor: crosshair;
    position: absolute; top:0px; left:0px;
    z-index: -1;
}

.c240-preview-canvas-wrapper {
    position: relative;
    width:  60vw;
    height: 26vw;
    margin: auto;
}

.c240-brush-eraser-prev-canvas-new {
    width: 60vw;
    height: 26vw;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    /* border: 1px solid black; */
}

.c240-region-selection-canvas-small-2by3 {
    width: 42vw;
    height: 26.2vw;
    background-size: 100% 100%;
    cursor: crosshair;
    position: absolute; top:0px; left:0px;
    z-index: -1;
}

.c240-preview-canvas-wrapper-2by3 {
    position: relative;
    width: 42vw;
    height: 26vw;
    margin: auto;
}

.c240-brush-eraser-prev-canvas-new-2by3 {
    width: 42vw;
    height: 26vw;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    /* border: 1px solid black; */
}


.brush-eraser-prev-canvas-new {
    width:65vw;
    height:auto;
    background-size: 100% 100%;
    position:absolute; top:0px; left:0px;
    z-index: -1;
    /* border: 1px solid black; */
}

.preview-canvas-wrapper {
    position:relative;
    width:30vw;
    height:10vw;
    margin: auto;
}

.preview-canvas-wrapper-new {
    position:relative;
    width:65vw;
    height:auto;
    margin: auto;
}

.summary-slot-div {
    margin-top: 32px;
}

.slide-name-input {
    width: 80% !important;
}

.summary-preview {
    width:30vw;
    height:10vw;
    display: block;
}

.summary-barcode {
    height:10vw;
    display: block;
}

.barcode {
    height:10vw;
    float: left;
    display: block;
}

.barcode-new {
    height:20vw;
    float: left;
    display: block;
}

.redo-slot-text {
    font-size: 10px;
    text-align: center;
}

.redo-slot-button {
    height: auto !important;
}

.summary-preview-list {
    margin-top:32px;
    height: 80vh;
}

.preview-for-region-selection {
    padding:2vw;
}

.slot-menu {
    padding:2vw;
}

.slot-tray-header {
    text-align: center;
    font-size:1.32px;
}

.scan-progress-section {
    text-align: center;
    font-size:1.32px;
}

.scan-progress-section-header {
    color:#777777;
}

.start-scan-button-div, .scan-all-button-div, .view-summary-button-div {
    text-align: center;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 32px;
    padding-top: 8px;
}

.scan-all-button-div {
    padding-top: 32px;
}

.view-summary-button-div {
    padding-bottom: 0;
}

.live-view {
    width: 30vw;
    padding:32px;
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.start-scan-button, .scan-all-button {
    animation: shadow-pulse 1s infinite;
}

.device-name {
    color:#5e5e5e;
}

.device-name:link {
    text-decoration: none;
}

.device-name:visited {
    text-decoration: none;
}

.device-name:hover {
    color:#5e5e5e;
    text-decoration: none;
}

@keyframes shadow-pulse
{
     0% {
          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);
     }
     100% {
          box-shadow: 0 0 0 5px rgba(0, 0, 0, 0);
     }
}

@keyframes shadow-pulse2
{
     0% {
          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
     }
     100% {
          box-shadow: 0 0 0 5px rgba(0, 0, 0, 0);
     }
}

@keyframes shadow-pulse3
{
     0% {
          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);
     }
     100% {
          box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
     }
}

.relativeParent {
    position: relative;
}

.absoluteChild {
    position: absolute;
    top: 46%;
    left: 47%;
}

.absoluteChildUp {
    position: absolute;
    top: 0%;
    left: 46%;
}

.absoluteChildLeft {
    position: absolute;
    top: 46%;
    left: 0%;
}

.absoluteChildDown {
    position: absolute;
    bottom: 0%;
    left: 46%;
}

.absoluteChildRight {
    position: absolute;
    top: 46%;
    right: 0%;
}

.absoluteChildTextUp {
    position: absolute;
    top: 8%;
    left: 46%;
}

.absoluteChildTextLeft {
    position: absolute;
    top: 48%;
    left: 8%;
}

.absoluteChildTextDown {
    position: absolute;
    bottom: 8%;
    left: 46%;
}

.absoluteChildTextRight {
    position: absolute;
    top: 48%;
    right: 8%;
}

.scanner-name-div {
    height: 6vh;
}


/* C240-Gate-Prompt */
.close-gate-info-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.close-gate-checkbox-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
}


.black-scanner-btn{
    background-color: black !important;
    color: white !important;
    border-color: transparent !important;
    text-align: left;
}

.black-scanner-btn:disabled{
    color: white !important ;
    background-color: gray !important;
}

.black-btn-disabled{
    color: white !important ;
    background-color: #d3d3d3 !important;
}

.radio-group-button  {
    color: white !important;
}

.ant-radio-button-wrapper:hover{
    color: black !important;
}

.radio-group-button .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    background-color: black !important;
    color: #fff !important;
    border-color: black;
    box-shadow: -1px 0 0 0;
}

.radio-group-button .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    background-color: black;
    color: #fff;
    border-color: black;
    box-shadow: -1px 0 0 0;
}

.shutdown-scanner-btn {
    background-color: #c54242 !important;
    color: aliceblue !important;
    border-color: #c54242 !important;
}

.shutdown-scanner-btn:hover {
    background-color: #c54242 !important;
    color: aliceblue !important;
    border-color: #ce2828 !important;
}

.shutdown-scanner-btn:disabled {
    background-color: #c57373 !important;
    color: aliceblue !important;
    border-color: #c57373 !important;
}

/* antd css changes for scanner workflow only */

.ant-tabs-nav .ant-tabs-tab-active {
    color: #000 !important;
}

.ant-switch-checked {
    background-color: rgba(11, 11, 11, 0.9) !important;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/scanner/scanner.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;;AAGA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB;AACJ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,UAAU;IACV,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,WAAW;AACf;;AAEA;IACI,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,WAAW;AACf;;;AAGA;;;CAGC;AACD;IACI,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,iBAAiB,EAAE,KAAK,EAAE,MAAM;IAChC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB,EAAE,OAAO,EAAE,QAAQ;IACrC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB,EAAE,OAAO,EAAE,QAAQ;IACrC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,6BAA6B;AACjC;;;AAGA;IACI,UAAU;IACV,WAAW;IACX,0BAA0B;IAC1B,iBAAiB,EAAE,OAAO,EAAE,QAAQ;IACpC,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;;KAEK;UACK,sCAAsC;KAC3C;KACA;UACK,sCAAsC;KAC3C;AACL;;AAEA;;KAEK;UACK,sCAAsC;KAC3C;KACA;UACK,sCAAsC;KAC3C;AACL;;AAEA;;KAEK;UACK,sCAAsC;KAC3C;KACA;UACK,uCAAuC;KAC5C;AACL;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;;AAGA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;;AAGA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA,+CAA+C;;AAE/C;IACI,sBAAsB;AAC1B;;AAEA;IACI,kDAAkD;AACtD","sourcesContent":[".rounded-container {\n    background: #ffffff;\n    border-radius: 8px;\n    margin: 8px;\n}\n\n.scanner-name {\n    font-size: 40px;\n    font-weight: 350;\n    vertical-align: center;\n    text-align: center;\n}\n\n.scanner-status {\n    font-size:8px;\n    vertical-align: middle;\n}\n\n.scanner-status-error {\n    font-size:24px;\n    text-align: center\n}\n\n.click-to-go-to-dash {\n    width: 100% !important;\n    text-align: center;\n}\n\n\n.scanner-main-control-buttons {\n    font-size:18px;\n    text-align: center;\n    padding:1vw;\n}\n\n.scanner-start-button { \n    width: 50%;\n    margin: 12px;\n    font-size: 16px !important;\n    font-weight: bold;\n}\n\n.scanner-start-button-div {\n    text-align: center;\n}\n\n.scanner-start-button:hover{\n    background-color: rgba(86, 46, 130, 0.06) !important;\n    border: 1px solid #562e82;\n}\n\n.hardware-status-panel {\n    border: 1px #d4d4d4 solid;\n    border-radius: 8px;\n    padding: 3px;\n    margin-top: 32px;\n    margin-bottom: 32px;\n}\n\n.hardware-status-row {\n    border: 1px #c7bfbf solid;\n    border-radius: 8px;\n    padding: 8px !important;\n    margin: 20px !important;\n}\n\n.hardware-section-header {\n    text-align: center;\n    font-size: 16px;\n}\n\n.hardware-section-retry {\n    font-size: 13px;\n}\n\n.power-fail-message {\n    text-align: center;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.troubleshoot-fail-message {\n    text-align: center;\n    font-weight: bold;\n    font-size: 18px;\n}\n\n.troubleshoot-steps {\n    margin: 32px;\n}\n\n.hardware-status-icon {\n    text-align: center;\n    font-size: 32px;\n    line-height: 48px !important;\n    vertical-align: middle;\n}\n\n.hardware-status-icon-div{\n    text-align: center;\n}\n\n.scanner-main-control-icon {\n    font-size:48px;\n    padding: 1vw;\n    padding-bottom: 0.5vw;\n}\n\n.scanner-main-control-icon-retake {\n    font-size:16px;\n    padding: 1vw;\n    padding-bottom: 0.5vw;\n}\n\n.scanner-busy-card {\n    vertical-align: middle;\n    text-align: center;\n    margin:10vw;\n}\n\n.scan-workflow-init {\n    vertical-align: middle;\n    text-align: center;\n    font-size:1.32px;\n}\n\na.scanner-user-controls{\n    color:inherit;\n}\n\n.slot-header {\n    font-size: 24px;\n    text-align: center;\n    font-family: Arial, Helvetica, sans-serif\n}\n\n.arial-font {\n    font-family: Arial, Helvetica, sans-serif;\n}\n\n.region-selection-canvas {\n    width:30vw;\n    height:9vw;\n    background-size: 100% 100%;\n    cursor: crosshair;\n    position:absolute;\n    top:0;\n    left:0;\n    z-index: -1;\n}\n\n.region-selection-canvas-new {\n    width:65vw;\n    height:auto;\n    background-size: 100% 100%;\n    cursor: crosshair;\n    position:absolute;\n    top:0; \n    left:0;\n    z-index: -1;\n}\n\n\n/* was \nwidth: 50vw;\nheight: 23.5vw;\n*/\n.c240-region-selection-canvas {\n    width:60vw;\n    height:26vw;\n    background-size: 100% 100%;\n    cursor: crosshair;\n    position:absolute; top:0; left:0;\n    z-index: -1;\n}\n\n.c240-region-selection-canvas-small {\n    width: 60vw;\n    height: 26vw;\n    background-size: 100% 100%;\n    cursor: crosshair;\n    position: absolute; top:0px; left:0px;\n    z-index: -1;\n}\n\n.c240-preview-canvas-wrapper {\n    position: relative;\n    width:  60vw;\n    height: 26vw;\n    margin: auto;\n}\n\n.c240-brush-eraser-prev-canvas-new {\n    width: 60vw;\n    height: 26vw;\n    background-size: 100% 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    /* border: 1px solid black; */\n}\n\n.c240-region-selection-canvas-small-2by3 {\n    width: 42vw;\n    height: 26.2vw;\n    background-size: 100% 100%;\n    cursor: crosshair;\n    position: absolute; top:0px; left:0px;\n    z-index: -1;\n}\n\n.c240-preview-canvas-wrapper-2by3 {\n    position: relative;\n    width: 42vw;\n    height: 26vw;\n    margin: auto;\n}\n\n.c240-brush-eraser-prev-canvas-new-2by3 {\n    width: 42vw;\n    height: 26vw;\n    background-size: 100% 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: -1;\n    /* border: 1px solid black; */\n}\n\n\n.brush-eraser-prev-canvas-new {\n    width:65vw;\n    height:auto;\n    background-size: 100% 100%;\n    position:absolute; top:0px; left:0px;\n    z-index: -1;\n    /* border: 1px solid black; */\n}\n\n.preview-canvas-wrapper {\n    position:relative;\n    width:30vw;\n    height:10vw;\n    margin: auto;\n}\n\n.preview-canvas-wrapper-new {\n    position:relative;\n    width:65vw;\n    height:auto;\n    margin: auto;\n}\n\n.summary-slot-div {\n    margin-top: 32px;\n}\n\n.slide-name-input {\n    width: 80% !important;\n}\n\n.summary-preview {\n    width:30vw;\n    height:10vw;\n    display: block;\n}\n\n.summary-barcode {\n    height:10vw;\n    display: block;\n}\n\n.barcode {\n    height:10vw;\n    float: left;\n    display: block;\n}\n\n.barcode-new {\n    height:20vw;\n    float: left;\n    display: block;\n}\n\n.redo-slot-text {\n    font-size: 10px;\n    text-align: center;\n}\n\n.redo-slot-button {\n    height: auto !important;\n}\n\n.summary-preview-list {\n    margin-top:32px;\n    height: 80vh;\n}\n\n.preview-for-region-selection {\n    padding:2vw;\n}\n\n.slot-menu {\n    padding:2vw;\n}\n\n.slot-tray-header {\n    text-align: center;\n    font-size:1.32px;\n}\n\n.scan-progress-section {\n    text-align: center;\n    font-size:1.32px;\n}\n\n.scan-progress-section-header {\n    color:#777777;\n}\n\n.start-scan-button-div, .scan-all-button-div, .view-summary-button-div {\n    text-align: center;\n    padding-left: 32px;\n    padding-right: 32px;\n    padding-bottom: 32px;\n    padding-top: 8px;\n}\n\n.scan-all-button-div {\n    padding-top: 32px;\n}\n\n.view-summary-button-div {\n    padding-bottom: 0;\n}\n\n.live-view {\n    width: 30vw;\n    padding:32px;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.start-scan-button, .scan-all-button {\n    animation: shadow-pulse 1s infinite;\n}\n\n.device-name {\n    color:#5e5e5e;\n}\n\n.device-name:link {\n    text-decoration: none;\n}\n\n.device-name:visited {\n    text-decoration: none;\n}\n\n.device-name:hover {\n    color:#5e5e5e;\n    text-decoration: none;\n}\n\n@keyframes shadow-pulse\n{\n     0% {\n          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);\n     }\n     100% {\n          box-shadow: 0 0 0 5px rgba(0, 0, 0, 0);\n     }\n}\n\n@keyframes shadow-pulse2\n{\n     0% {\n          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);\n     }\n     100% {\n          box-shadow: 0 0 0 5px rgba(0, 0, 0, 0);\n     }\n}\n\n@keyframes shadow-pulse3\n{\n     0% {\n          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.3);\n     }\n     100% {\n          box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);\n     }\n}\n\n.relativeParent {\n    position: relative;\n}\n\n.absoluteChild {\n    position: absolute;\n    top: 46%;\n    left: 47%;\n}\n\n.absoluteChildUp {\n    position: absolute;\n    top: 0%;\n    left: 46%;\n}\n\n.absoluteChildLeft {\n    position: absolute;\n    top: 46%;\n    left: 0%;\n}\n\n.absoluteChildDown {\n    position: absolute;\n    bottom: 0%;\n    left: 46%;\n}\n\n.absoluteChildRight {\n    position: absolute;\n    top: 46%;\n    right: 0%;\n}\n\n.absoluteChildTextUp {\n    position: absolute;\n    top: 8%;\n    left: 46%;\n}\n\n.absoluteChildTextLeft {\n    position: absolute;\n    top: 48%;\n    left: 8%;\n}\n\n.absoluteChildTextDown {\n    position: absolute;\n    bottom: 8%;\n    left: 46%;\n}\n\n.absoluteChildTextRight {\n    position: absolute;\n    top: 48%;\n    right: 8%;\n}\n\n.scanner-name-div {\n    height: 6vh;\n}\n\n\n/* C240-Gate-Prompt */\n.close-gate-info-block {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.close-gate-checkbox-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n}\n\n\n.black-scanner-btn{\n    background-color: black !important;\n    color: white !important;\n    border-color: transparent !important;\n    text-align: left;\n}\n\n.black-scanner-btn:disabled{\n    color: white !important ;\n    background-color: gray !important;\n}\n\n.black-btn-disabled{\n    color: white !important ;\n    background-color: #d3d3d3 !important;\n}\n\n.radio-group-button  {\n    color: white !important;\n}\n\n.ant-radio-button-wrapper:hover{\n    color: black !important;\n}\n\n.radio-group-button .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {\n    background-color: black !important;\n    color: #fff !important;\n    border-color: black;\n    box-shadow: -1px 0 0 0;\n}\n\n.radio-group-button .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {\n    background-color: black;\n    color: #fff;\n    border-color: black;\n    box-shadow: -1px 0 0 0;\n}\n\n.shutdown-scanner-btn {\n    background-color: #c54242 !important;\n    color: aliceblue !important;\n    border-color: #c54242 !important;\n}\n\n.shutdown-scanner-btn:hover {\n    background-color: #c54242 !important;\n    color: aliceblue !important;\n    border-color: #ce2828 !important;\n}\n\n.shutdown-scanner-btn:disabled {\n    background-color: #c57373 !important;\n    color: aliceblue !important;\n    border-color: #c57373 !important;\n}\n\n/* antd css changes for scanner workflow only */\n\n.ant-tabs-nav .ant-tabs-tab-active {\n    color: #000 !important;\n}\n\n.ant-switch-checked {\n    background-color: rgba(11, 11, 11, 0.9) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
